import { toCdnImageUrl } from './imageCdn'
import type {
  ConstructorImage,
  ConstructorResult,
  ConstructorResultData,
  PairsWithProduct,
  SimilarProduct,
} from './types'

const FULFILLMENT_MB = 'material bank fulfilled'
const FULFILLMENT_BRAND = 'brand fulfilled'

// The data fields the mappers below read. Asking Constructor for only these cuts
// each recommendations response to about a third, so keep it in step with them.
export const CONSTRUCTOR_RESULT_FIELDS: Array<keyof ConstructorResultData> = [
  'variation_id',
  'Brand_Name',
  'brand',
  'images',
  'group_ids',
  'inventory',
  'Fulfillment_Options',
  'search_hex_code',
  'Attribute_Set_Code',
]

export function computeIsOutOfStock(
  inventory: number | undefined,
  fulfillmentOptions: string[],
): boolean {
  const opts = fulfillmentOptions.map((o) => o.toLowerCase())
  const hasMBFulfillment = opts.includes(FULFILLMENT_MB)
  const hasBrandFulfillment = opts.includes(FULFILLMENT_BRAND)
  const hasMbInventory = typeof inventory === 'number' && inventory >= 5

  if (!hasMBFulfillment && hasBrandFulfillment) {
    return true
  }

  return !hasMbInventory
}

export function resolveImageUrls(images?: ConstructorImage[]): {
  mainImageUrl: string
  installImageUrl: string | null
} {
  if (!images || images.length === 0) {
    return { mainImageUrl: '', installImageUrl: null }
  }

  const mainImage = images.find(
    (img) => img.label?.toLowerCase().includes('main'),
  )

  const installImage = images.find(
    (img) => img.label?.toLowerCase().includes('install'),
  )

  return {
    mainImageUrl: toCdnImageUrl(mainImage?.url ?? images[0].url),
    installImageUrl: installImage?.url ? toCdnImageUrl(installImage.url) : null,
  }
}

export function toSimilarProduct(result: ConstructorResult): SimilarProduct {
  const { data, value } = result
  const images = resolveImageUrls(data.images)

  const hoverImage =
    data.images?.find((img) => img.label?.toLowerCase().includes('install')) ??
    null
  const mainImage =
    data.images?.find((img) => img.label?.toLowerCase().includes('main')) ??
    null

  return {
    id: data.variation_id,
    name: value ?? '',
    brand: data.Brand_Name ?? data.brand ?? null,
    imageUrl: images.mainImageUrl,
    installImageUrl: images.installImageUrl,
    groupId: data.group_ids?.[0] ?? null,
    hoverImage,
    mainImage,
    isOutOfStock: computeIsOutOfStock(
      data.inventory,
      data.Fulfillment_Options ?? [],
    ),
    searchHexCode: data.search_hex_code ?? null,
  }
}

export function toPairsWithProduct(
  result: ConstructorResult,
): PairsWithProduct {
  const { data, value } = result
  const images = resolveImageUrls(data.images)

  return {
    id: data.variation_id,
    name: value ?? '',
    brand: data.Brand_Name ?? data.brand ?? null,
    imageUrl: images.mainImageUrl,
    installImageUrl: images.installImageUrl,
    groupId: data.group_ids?.[0] ?? null,
    category: data.Attribute_Set_Code ?? 'other',
    searchHexCode: data.search_hex_code ?? null,
  }
}
